import styled from 'styled-components';
import { useState } from 'react';
import { styles } from './components/styles';

const Tags = ({ data }: any) => {
  function processItem(item: any) {
    if (!item.bidno) {
      // bidno가 없는 경우
      const match = String(item.bid).match(/\d+/); // bid를 문자열로 변환 후 숫자 추출
      if (match) {
        item.bidno = match[0]; // 숫자를 bidno로 추가
      }
    }
    return item;
  }
  const item = processItem(data);
  const MAX_VISIBLE_TAGS = 2;
  const [showAllTags, setShowAllTags] = useState(false);
  const tags =
    (item.viewgray2 &&
      item.viewgray2
        ?.trim() // 공백 제거
        .replace(/\[|\]/g, '') // 대괄호 제거
        .split(' / ') // ' / ' 기준으로 분리
        .filter((el: string) => el.trim().length > 0)) ||
    []; // 공백 제외
  const hiddenTagCount = tags.length - MAX_VISIBLE_TAGS;
  return (
    <TagBox>
      <div style={styles.tags}>
        {item.bidno && item.bidno > 0 && item.bidno !== null && (
          <BidTag>{'유찰' + item.bidno + '회'}</BidTag>
        )}
        {String(item.bid).trim() === '매각' && <BidTag>낙찰</BidTag>}
        {String(item.bid).trim() === '신건' && (
          <BidTag
            style={{
              color: '#1F9E54',
              backgroundColor: '#E6F4F0',
            }}
          >
            신건
          </BidTag>
        )}
        {(showAllTags ? tags : tags.slice(0, MAX_VISIBLE_TAGS)).map(
          (el: any, index: any) => (
            <div style={styles.tag} key={index}>
              <span style={styles.tagText}>{el}</span>
            </div>
          ),
        )}

        {hiddenTagCount > 0 && !showAllTags && (
          <div
            style={styles.tagClick}
            onClick={(e) => {
              e.stopPropagation();
              setShowAllTags(true);
            }}
          >
            <span style={styles.tagText}>+{hiddenTagCount}</span>
          </div>
        )}

        {showAllTags && (
          <div
            style={styles.tagClick}
            onClick={(e) => {
              e.stopPropagation();
              setShowAllTags(false);
            }}
          >
            <span style={styles.tagText}>접기</span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt=""
              style={{ width: '16px', transform: 'rotate(180deg)' }}
            />
          </div>
        )}
      </div>
    </TagBox>
  );
};

export default Tags;

const BidTag = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #f45551;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #ffefef;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  flex-wrap: wrap;
`;
